import { type TimelineItem } from 'apps/employer_renewals/components/timeline/Timeline'

import ContentLayout, { type InfoSection } from './ContentLayout'

type Props = {
  showBackToDashboardButton?: boolean
}

const timelineItems: TimelineItem[] = [
  {
    title: 'Today',
    body: 'Review your estimated 2026 costs and adjust your allowance strategy. ',
    isCompleted: true,
  },
  {
    title: 'By Nov 4',
    body: "We'll let you know once your team's rates are finalized, but every state will vary.",
    isActive: true,
  },
  {
    title: 'Nov 4',
    body: 'Your last day to review and confirm your 2026 allowance strategy.',
  },
  {
    title: 'Nov 5',
    body: 'Open Enrollment begins for 2026. Your employees will be invited to start enrolling in their plans, and coverage will begin Jan 1.',
  },
]

const infoSections: InfoSection[] = [
  {
    title: "What's next",
    body: [
      "Insurance companies finalize their prices on a rolling, state-by-state basis.  We'll let you know when insurance prices in areas where your employees live are finalized.",
      "Since final prices can be different from original estimates, you'll be able to adjust as you see fit.",
    ],
  },
  {
    title: "What happens if you don't do anything?",
    body: [
      'Eligible employees will be invited on Nov 5 to choose their insurance plans for 2026 based on the strategy you selected today.',
      'Invited employees may receive enrollment reminders via email and SMS. They can opt out anytime.',
    ],
  },
]

export default function PreliminaryContent ({ showBackToDashboardButton }: Props) {
  return (
    <ContentLayout
      timelineItems={timelineItems}
      infoSections={infoSections}
      showBackToDashboardButton={showBackToDashboardButton}
    />
  )
}
